import React from "react"
import ReactDOM from "react-dom"
import { Bar, Pie } from "react-chartjs-2"
/**
 * 
 * @param {id} id - the dom node identifier to be replaced
 * @param {chart data} chart_data - the data to be passed to the chart
 * @param {chart type} chart_type - the type of chart. 0 represents bar, 1 represent pie
 */
export function barChart (id, chart_data, chart_type) {
    
  let getChart = () => {
    let data = JSON.parse( chart_data )[ id ]
   
    if (chart_type == 0) return <Bar data={data} />
    if (chart_type == 1) return <Pie data={data} />
        }
 
  

    let chart1 = document.getElementById(id)
    if(chart1 == null || chart1 == undefined) return
    
    var div = document.createElement("div")
    ReactDOM.render(getChart(), chart1)
    chart1.appendChild(div)
}